import React, { useEffect } from 'react'

// Componente para prevenir traducción automática del navegador
const TranslationPreventer = ({ children }) => {
  useEffect(() => {
    // Prevenir traducción automática usando múltiples métodos
    
    // 1. Agregar atributo translate="no" al documento
    document.documentElement.setAttribute('translate', 'no')
    document.body.setAttribute('translate', 'no')
    
    // 2. Deshabilitar Google Translate
    const disableGoogleTranslate = () => {
      // Remover el script de Google Translate si existe
      const googleTranslateScript = document.querySelector('script[src*="translate.googleapis.com"]')
      if (googleTranslateScript) {
        googleTranslateScript.remove()
      }
      
      // Remover el div de Google Translate si existe
      const googleTranslateDiv = document.querySelector('#google_translate_element')
      if (googleTranslateDiv) {
        googleTranslateDiv.remove()
      }
      
      // Remover clases de traducción
      document.documentElement.classList.remove('translated-ltr', 'translated-rtl')
      document.body.classList.remove('translated-ltr', 'translated-rtl')
    }
    
    // 3. Interceptar cambios de DOM para prevenir traducción
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Agregar translate="no" a elementos nuevos
              node.setAttribute('translate', 'no')
              
              // Remover clases de traducción
              if (node.classList) {
                node.classList.remove('translated-ltr', 'translated-rtl')
              }
              
              // Aplicar a elementos hijos
              const children = node.querySelectorAll('*')
              children.forEach(child => {
                child.setAttribute('translate', 'no')
                if (child.classList) {
                  child.classList.remove('translated-ltr', 'translated-rtl')
                }
              })
            }
          })
        }
      })
    })
    
    // 4. Observar cambios en el DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
    
    // 5. Prevenir eventos de traducción
    const preventTranslationEvents = (e) => {
      // Prevenir eventos de Google Translate
      if (e.target && (
        e.target.classList.contains('goog-te-banner-frame') ||
        e.target.classList.contains('goog-te-menu-frame') ||
        e.target.id === 'google_translate_element'
      )) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    }
    
    // Agregar listeners de eventos
    document.addEventListener('DOMNodeInserted', preventTranslationEvents, true)
    document.addEventListener('DOMSubtreeModified', preventTranslationEvents, true)
    
    // 6. Ejecutar limpieza inicial
    disableGoogleTranslate()
    
    // 7. Limpieza periódica
    const cleanupInterval = setInterval(disableGoogleTranslate, 1000)
    
    // Cleanup al desmontar
    return () => {
      observer.disconnect()
      document.removeEventListener('DOMNodeInserted', preventTranslationEvents, true)
      document.removeEventListener('DOMSubtreeModified', preventTranslationEvents, true)
      clearInterval(cleanupInterval)
    }
  }, [])
  
  return <>{children}</>
}

export default TranslationPreventer

